<template>
  <div class="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-4 bg-white">
    <img :src="LogoUrl" alt="MJ" class="h-24 w-24 object-contain" />
    <IconLoader2 class="animate-spin text-gray-400" size="32" />
    <span class="text-base text-gray-500">{{ t('action.pleaseWait') }}</span>
  </div>
</template>

<script setup lang="ts">
import { IconLoader2 } from '@tabler/icons-vue'
import { useI18n } from 'vue-i18n'
import LogoUrl from '@/assets/mudjai/MJ-Logo_Icon.png'

defineOptions({ name: 'SplashScreen' })

const { t } = useI18n()
</script>
